import Vue from 'vue'
import Vuex from 'vuex'
import userData from './userData/index.js'
import Clients from './clients/index.js'
import Fines from './dictionaries/Fines/index.js'
import Cars from './dictionaries/Cars/index.js'
import Partners from './partners/index.js'
import Cities from './dictionaries/Cities/index.js'
import OrgBranches from './dictionaries/OrgBranches/index.js'
import Bonuses from './dictionaries/Bonuses/index.js'
import PartnerTypes from './dictionaries/PartnerTypes/index.js'
import Stocks from './dictionaries/Stocks/index.js'
import RequestCategories from './dictionaries/RequestCategories/index.js'
import Requests from './requests/index.js'
import Chats from './chats/index.js'
import Notifications from './notifications/index.js'
import SupportRequests from './supportRequests/index.js'
import ActivationBonus from './bonusActivation/index.js'
import Statistic from './statistic/index.js'

Vue.use(Vuex);

export default new Vuex.Store({

    modules: {
        userData,
        SupportRequests,
        Clients,
        Fines,
        Cities,
        Bonuses,
        PartnerTypes,
        OrgBranches,
        Chats,
        Stocks,
        Cars,
        Requests,
        Partners,
        RequestCategories,
        Notifications,
        ActivationBonus,
        Statistic

    }
})
